module.exports = __webpack_public_path__ + "img/amazake_logo.fc36871f.png";